import React from 'react';
import { Section } from './Section';
import type { LegalItem, LegalSection } from '../types/legal';
type LegalDocProps = {
  title: string;
  updated: string;
  sections: LegalSection[];
  /** Optional closing note under the last section. */
  note?: string;
};

/** Shared layout for Terms of Service and Privacy Policy. */
export function LegalDoc({
  title,
  updated,
  sections,
  note
}: LegalDocProps) {
  return <>
      <Section label="Legal" noTop contentClassName="page-hero" data-id="element-288" data-mp="2ej07iig10ild">
        <h1 className="h1" data-id="element-289" data-mp="2jgrx35t77sme">{title}</h1>
        <p className="terms-upd" data-id="element-290" data-mp="2jhupxja3054y">Last Updated: {updated}</p>
      </Section>

      <Section label={title === 'Privacy Policy' ? 'Privacy' : 'Terms'} contentClassName="terms" data-id="element-291" data-mp="2nidixgnpnh8q">
        {sections.map(s => <section key={s.h} className="terms-s" data-id="element-292" data-mp="2sjaydlhc5x6j">
            <h2 data-id="element-293" data-mp="2so3b1f6nrez">{s.h}</h2>
            {s.body.map((b, i) => {
          if (b.t === 'ul') {
            return <ul key={i} data-id="element-294" data-mp="7qhbu13ykxif">
                    {b.items.map((item, k) => <li key={k} data-id="element-295" data-mp="3n3ixp3ykq6dq" data-mpi={k}>{renderItem(item)}</li>)}
                  </ul>;
          }
          if (b.t === 'h3') return <h3 key={i} data-id="element-296" data-mp="3i1tjxgjyvely">{b.x}</h3>;
          if (b.t === 'caps') return <p key={i} className="caps" data-id="element-297" data-mp="3d3s02tepvb9f">{b.x}</p>;
          return <p key={i} data-id="element-298" data-mp="385qkiigi1u2p" data-mpi={i}>{renderItem(b.x)}</p>;
        })}
          </section>)}
        {note && <p className="terms-note" data-id="element-299" data-mp="344510e9gmhjj">{linkify(note)}</p>}
        <p className="terms-upd" data-id="element-300" data-mp="345ogw3r7eqks">Last Updated: {updated}</p>
      </Section>
    </>;
}
function renderItem(item: LegalItem) {
  if (typeof item === 'string') return linkify(item);
  return <>
      <strong data-id="element-301" data-mp="2uettgw281kxr">{item[0]}</strong> {linkify(item[1])}
    </>;
}
const EMAIL = /([a-z0-9._-]+@meetsynthia\.ai)/gi;

/** Turns any meetsynthia.ai address in the copy into a mailto link. */
function linkify(text: string) {
  return text.split(EMAIL).map((part, i) => i % 2 === 1 ? <a key={i} href={`mailto:${part}`} data-id="element-302" data-mp="2gflv25dvugum">
        {part}
      </a> : <React.Fragment key={i} data-id="element-303" data-mp="25sxjcesmdr7y">{part}</React.Fragment>);
}